<fgb-account-layout [memberName]="name() ?? ''" [pageTitle]="'account.activity.page.title'" [backButtonLink]="'/'">
  <div class="container">
    <div class="item-container">
      <fgb-subscriptions-list></fgb-subscriptions-list>

      <div
        class="rounded bg-white border font-size-14 sub-opt-out"
        [innerHTML]="'account.opt.out.language' | translate | markdownTranslate"
      ></div>
    </div>
  </div>
